import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { PagesAPI } from '../services/api';
import Markdown from '../components/Markdown';

export default function Page({ category: propCategory }) {
  const params = useParams();
  const category = params.category || propCategory;
  const { slug } = params;
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const data = await PagesAPI.getPage(category, slug);
        setPage(data.page);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [category, slug]);

  const categoryTitles = {
    foreningen: 'Föreningen',
    ansvarsomraden: 'Ansvarsområden',
    nedingen: 'Sjön Nedingen'
  };

  if (loading) {
    return <div className="loading">Laddar...</div>;
  }

  if (error || !page) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
        <h2>Sidan hittades inte</h2>
        <p>Sidan du söker finns inte eller har flyttats.</p>
        <Link to="/" className="btn btn-primary" style={{ marginTop: '1rem' }}>
          Till startsidan
        </Link>
      </div>
    );
  }

  return (
    <>
      <div style={{
        background: 'var(--forest)',
        padding: '5rem 2rem 3.5rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'url(/Fornbo.jpg) center 35% / cover no-repeat',
          opacity: 0.12,
          pointerEvents: 'none'
        }} />
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            fontSize: '0.7rem',
            fontWeight: 700,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--sand)',
            marginBottom: '0.75rem'
          }}>
            <Link to="/" style={{ color: 'var(--sand)', opacity: 0.7 }}>Startsida</Link>
            {' / '}
            <Link to={`/#${category}`} style={{ color: 'var(--sand)', opacity: 0.7 }}>
              {categoryTitles[category]}
            </Link>
            {' / '}
            {page.title}
          </div>
          <h1 style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            color: '#fff',
            lineHeight: 1.2,
            marginBottom: '0.6rem'
          }}>
            {page.title}
          </h1>
        </div>
      </div>
      
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '3.5rem 2rem 5rem'
      }}>
        <div className="fade-in visible">
          <Markdown content={page.content} />
        </div>
      </div>
    </>
  );
}
